var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import NumTypeSelect from "~/components/dashboard/num-type-select.vue";
import { VeHistogram } from "v-charts";
import { Dependencies } from "~/core/decorator";
import { HomePageService } from '~/services/domain-service/home-page.service';
var CaseRepayChart = /** @class */ (function (_super) {
    __extends(CaseRepayChart, _super);
    function CaseRepayChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentNumType = 0;
        _this.date = new Date();
        _this.dateDay = [];
        _this.type = 'month';
        _this.caseRepayChart = {
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    var color1 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFFF99;"></span>';
                    var color2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#99CC00;"></span>';
                    var index1 = (params.length > 0 && params[0].value) ? params[0].value : 0;
                    var index2 = (params.length > 1 && params[1].value) ? params[1].value : 0;
                    var index3 = (params.length > 2 && params[2].value) ? params[2].value : 0;
                    var index4 = (params.length > 3 && params[3].value) ? params[3].value : 0;
                    var repaynum = index1 + index3;
                    var repaycount = (index2 * 100 + index4 * 100) / 100;
                    var str0 = '';
                    if (params.length > 0) {
                        str0 = params[0].marker + "" + params[0].seriesName + "：" + index1 + "<br/>";
                    }
                    var str1 = '';
                    if (params.length > 1) {
                        str1 = params[1].marker + "" + params[1].seriesName + "：" + index2 + "<br/>";
                    }
                    var str2 = '';
                    if (params.length > 2) {
                        str2 = params[2].marker + "" + params[2].seriesName + "：" + index3;
                    }
                    var str3 = '';
                    if (params.length > 3) {
                        str3 = params[3].marker + "" + params[3].seriesName + "：" + index4 + "<br/>";
                    }
                    return color2 + "总金额：" + repaycount + "<br/>" + str1 + str3 + color1 + "总笔数：" + repaynum + "<br/>" + str0 + str2;
                }
            },
            data: {
                columns: ['日期', '待确认笔数', '待确认金额', '已到账笔数', '已到账金额'],
                rows: []
            },
            setting: {
                stack: {
                    '日期': ['待确认笔数', '已到账笔数'],
                    '111': ['待确认金额', '已到账金额']
                }
            },
            legend: {
                x: 'center',
                y: 'top'
            },
            dataZoom: [
                {
                    type: 'slider',
                    show: false,
                    maxValueSpan: 14,
                },
                {
                    type: 'inside',
                    maxValueSpan: 14,
                    zoomLock: true
                }
            ]
        };
        _this.extend = {
            series: {
                barWidth: 25,
            }
        };
        return _this;
    }
    CaseRepayChart.prototype.onChange = function () {
        this.updateData();
    };
    CaseRepayChart.prototype.typeModelChange = function (val) {
        if (val === 'month')
            this.dateDay = [];
        else
            this.date = '';
    };
    CaseRepayChart.prototype.updateData = function () {
        var _this = this;
        var date = new Date(this.date);
        // 按日的时候year的参数传什么都可以
        var year = this.type === 'month' ? date.getFullYear() : '1';
        var time = {
            startDate: this.dateDay.length ? this.$filter.dateRanageFormat(this.dateDay).start : '',
            endDate: this.dateDay.length ? this.$filter.dateRanageFormat(this.dateDay).end : ''
        };
        var params = __assign({ timeType: this.type, year: year }, time);
        this.homePageService.getRepaymentChart(params).subscribe(function (data) {
            _this.caseRepayChart.data.rows = data;
            _this.caseRepayChart.dataZoom[0].show = (data.length > 15);
        });
    };
    CaseRepayChart.prototype.mounted = function () {
        this.updateData();
    };
    __decorate([
        Dependencies(HomePageService)
    ], CaseRepayChart.prototype, "homePageService", void 0);
    CaseRepayChart = __decorate([
        Component({
            components: {
                VeHistogram: VeHistogram,
                NumTypeSelect: NumTypeSelect
            }
        })
    ], CaseRepayChart);
    return CaseRepayChart;
}(Vue));
export default CaseRepayChart;
